import { trpc } from 'root/src/client/v2/trpc/trpc';
import { memo } from 'react';
import { CreatorDaresProvider } from 'root/src/client/web/record/CreatorData/CreatorDare/creatorDares.context';
import { CreateCreatorDare } from 'root/src/client/web/record/CreatorData/CreatorDare/CreateCreatorDare';
import { CreatorDaresCarousel } from 'root/src/client/web/record/CreatorData/CreatorDare/CreatorDaresCarousel';
import { useIsCreator } from 'root/src/client/v2/auth/hooks/useIsCreator';
export const CreatorDares = memo(({ dropId }) => {
    const { isCreator } = useIsCreator();
    const creatorDaresQuery = trpc.dares.getDropCreatorEventFulfilledDares.useQuery({
        dropId,
    });
    const creatorDares = creatorDaresQuery.data || [];
    return (<CreatorDaresProvider dares={creatorDares} refetch={creatorDaresQuery.refetch} dropId={dropId}>
			<div className="flex flex-col gap-4">
				<p className="text-2xl font-mono font-bold">Creator Dares</p>
				<div className="flex gap-4 px-4 pt-8 pb-4">
					{isCreator && <CreateCreatorDare />}
					<CreatorDaresCarousel />
				</div>
			</div>
		</CreatorDaresProvider>);
});
